import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import FuelDialogHeader from '../fuel-dialog-header/fuel-dialog-header';
import { AlertType } from './FuelCalendarContainer';



interface IPros {
  // open: boolean;
  // onClose: () => void;
  // type: AlertType;
  confirm: (type: AlertType, isSeries: boolean) => void;
}
const CustomConfirmDialog = ({ confirm}: IPros, ref) => {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState('');

 useImperativeHandle(ref, () => ({
    open(type) {
      // console.log('open popover', {type});
      setOpen(true);
      setType(type);
    },
    close() {
      setOpen(false);
    }
  }));


  return (
    <div>
     {open && <Dialog open={open} maxWidth='xs' onClose={() => setOpen(false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <FuelDialogHeader onClose={() => setOpen(false)}>{type === 'Edit' ? 'Edit Event' : 'Delete Event'}</FuelDialogHeader>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            How would you like to change the event in the series?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="success" onClick={() => confirm(type, false)}>{type === 'Edit' ? 'Edit Event' : 'Delete Event'}</Button>
          <Button color='inherit' onClick={() => confirm(type, true)} autoFocus>
            Entire Series
          </Button>
        </DialogActions>
      </Dialog>}
    </div>
  );
};

export default forwardRef(CustomConfirmDialog);
